export const send = {
  methods: {
    send: function(redirect) {
      const self = this;

      dataLayer.push({
        event: "form-submitted",
        formname: "Trial Form",
        form_industry: self.formdata.industry.value,
        form_company_name: self.formdata.company.value,
        form_company_size: self.formdata.numOf.value,
        form_job_title: self.formdata.title.value
      });

      let account = self.formdata.email.value.split("@");
      account =
        self.formdata.account.value === ""
          ? account[1]
          : self.formdata.account.value;


      let mktoForm = MktoForms2.allForms()[0];
      let interest =
        self.formdata.interest.value != "Other"
          ? self.formdata.interest.value
          : self.formdata.interest_other.value;

      // Submit the form to Marketo through a hidden marketo form that is on the page.
      mktoForm.addHiddenFields({
        //These are the values which will be submitted to Marketo through hidden fields
        Email: self.formdata.email.value,
        FirstName: self.formdata.firstname.value,
        LastName: self.formdata.lastname.value,
        Title: self.formdata.title.value,
        Phone: self.formdata.phone.value,
        Vertical__c: self.formdata.industry.value,
        Company: self.formdata.company.value,
        Industry: self.formdata.industry.value,
        Use_Case__c: self.formdata.usecase.value,
        Country: self.formdata.country.value,
        State: self.formdata.state.value,
        locale: self.formdata.locale.value,
        subscriptionConsent: self.formdata.consent.value,
        Secondary_Campaign__c: self.formdata.sfdc,
        gclid: self.formdata.gclid,
        gacid: self.formdata.client_id,
        trialInterest: interest,
        trialTCs: self.formdata.terms.value,
        tryNowCreated: self.tryNowCreated
      });

      if (self.zoominfoData.run) {
        mktoForm.addHiddenFields({
          DOZISF__ZoomInfo_Id__c: self.zoominfoData.id,
          zoomInfoFormCompleteStatus: self.zoominfoData.meta.status
        });
      }

      if (self.isContent) {
        mktoForm.addHiddenFields({
          schoolPrincipal: self.formdata.curriculum.principal,
          contentTrialGrades: self.formdata.curriculum.grade,
          tryNowCreated: self.tryNowCreated
        });
      }

      if (self.isMasterclass) {
        mktoForm.addHiddenFields({
          masterclassCourses: self.formdata.checkboxes.join(",")
        });
      }

      if (self.isCustomer) {
        mktoForm.addHiddenFields({
          tryNowCustomer: true,
          message: self.formdata.message.value
        });
      }

      mktoForm.onSuccess(function() {
        window._vis_opt_queue = window._vis_opt_queue || [];
        window._vis_opt_queue.push(function() {
          _vis_opt_register_conversion(2, 51);
        }); // Used for a/b test conversions
        window._vis_opt_queue.push(function() {
          _vis_opt_goal_conversion(201);
        });

        self.$refs.form.dispatchEvent(
          new Event("submit", { cancelable: true })
        ); // Send form submit event for zoominfo

        if (redirect) {
          if (self.isCorp) {
            self.$router.push("/corp/thank-you/");
          } else {
            self.$router.push(`/${self.$route.params.segment}/thank-you/`);
          }
        } else if (self.isContent) {
          self.$router.push("/adventure/thank-you/");
        }

        return false;
      });

      mktoForm.submit();
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/exports/methods/send.js